// Angular 2
import { enableDebugTools, disableDebugTools } from '@angular/platform-browser';
import { ApplicationRef, enableProdMode } from '@angular/core';
// Environment Providers
var PROVIDERS = [
// common env directives
];
export var LOGINENDPOINTS = {
    GoogleClientId: "103054385536-lh6hij3l0v2gm9kmlqk7nv8dfndj0dva.apps.googleusercontent.com",
    LinkedInClientId: "78c8zs0f0dlxeb",
    login: "/authenticate",
    loginByGoogle: "/public/continueWithGoogle",
    signup: "/user/create/initial",
    country: "/data/countries",
    state: "/data/states/",
    filterState: "/data/filteredStates/",
    city: "/data/cities/",
    filterCity: "/data/filteredCities/",
    usertype: "/data/userTypes",
    filterUsertype: "/data/filteredUserTypes",
    eduins: "/data/educationalInstitutions",
    filterEduins: "/data/filteredEducationalInstitutions",
    signup2: "/user/preloginsecure/create/final/",
    secondaryData: "/view/profile/secondaryData",
    topcourse: "/public/topCourses",
    courseNameAutocomplate: "/public/autocompletes/courses/",
    openCourses: "/public/opencourses",
    searchCourse: "/public/search/courses",
    courseownerNameAutocomplate: "/public/autocompletes/tutors/",
    openCoursesFilters: "/public/courses/filters",
    getCourse: "/public/courses/",
    getTopic: "/topic/public/topic/",
    resendEamil: "/user/resendEmailConfirmation/",
    resendEmailPublic: "/public/resendEmailConfirmation",
    forgotPasswordOrResendEmail: "/public/forgotPasswordOrResendEmail",
    resetPassword: "/changePassword.do",
    searchUser: "/public/search",
    ipData: "/public/ipdata",
    location: "/public/location",
    generateOtp: "/myAccount/public/unsubscription/otp",
    submitOtp: "/myAccount/public/unsubscription/otp/validationCheck"
};
export var DASHBOARDENDPOINTS = {
    userSummary: "/homepage/userSummary",
    loggedInUser: "/getLoggedInUser",
    logOff: "/logOff",
    country: "/data/countries",
    filterState: "/data/filteredStates/",
    filterCity: "/data/filteredCities/",
    sessionExpiryCheck: "/sessionExpiryCheck",
    userSummary1: "/homepage/userSummary",
    topSearchget: "/universalsearch/",
    profileVisits: "/homepage/profileVisits",
    allProfileVisits: "/homepage/allProfileVisits",
    allProfileVisitsLoadMore: "/homepage/allProfileVisits?loadMore=",
    profileVisitsbyId: "/view/profile/",
    profilePercentage: "/homepage/profilePerecentageCompletion",
    profileVisitsCoursebyMeId: "/view/profile/getData/coursesByUser/",
    topCourses: "/homepage/topCourses",
    suggestFriends: "/homepage/suggestedFriends",
    hotTopics: "/homepage/hotTopics",
    hotJobs: "/homepage/hotJobs",
    sendInvitationReq: "/inbox/send/invitationRequest",
    networkUpdates: "/homepage/networkUpdates",
    networkUpdatesLoadMore: "/homepage/networkUpdates?loadMore=true",
    viewProfile: "/view/profile",
    editviewProfile: "/edit/profile",
    searchUser: "/search",
    updateUserProfileType: "/edit/profile/profileType",
    educationalQualification: "/edit/profile/educationalQualification",
    updateUserProfileTypeAndEducationalQualification: "/edit/profile/profileTypeEducationalQualification",
    degreeCourse: "/edit/profile/degreeCourse",
    linkedInProfile: "/edit/profile/linkedInProfile",
    getpastEducation: "/edit/profile/getData/pastEducations",
    addpastEducation: "/edit/profile/add/pasteducation",
    updatepastEducation: "/edit/profile/update/pasteducation",
    deletepastEducation: "/edit/profile/delete/pasteducation",
    editAboutMe: "/edit/profile/aboutMe",
    addSkills: "/edit/profile/userSkillsts",
    getSkills: "/edit/profile/getData/userSkillsts",
    addWorkExp: "/edit/profile/add/projectResearchExperience",
    getWorkExp: "/edit/profile/getData/projectResearchExperiences",
    coursesIRcmd: "/universalsearch/courses/",
    updateCiRcmd: "/edit/profile/coursesIRecommend",
    getCiRcmd: "/edit/profile/getData/coursesIRecommend",
    updateWorkExp: "/edit/profile/update/projectResearchExperience",
    deleteWorkExp: "/edit/profile/delete/projectResearchExperience",
    uploadImage: "/edit/profile/profilepic",
    userAccptRcmd: "/edit/profile/getData/userAcceptedRecommendations",
    updateuserAccptRcmd: "/edit/profile/userAcceptedRecommendations",
    myInterest: "/edit/profile/myInterests",
    viewcourseByMe: "/view/profile/getData/coursesByMe",
    editcourseByMe: "/edit/profile/getData/coursesByMe",
    myConnections: "/search",
    connAccept: "/inbox/accept/invitationRequest/",
    courseReq: "/inbox/send/courseRequest",
    rcmdRequest: "/inbox/send/recommendationRequest",
    rateRequest: "/inbox/send/ratingRequest",
    sendRatingForRequest: "/inbox/send/ratingInResponseToRequest/",
    inboxrcmdRequest: "/inbox/send/recommendation",
    renameRecording: "/session/video/rename",
    rcmdAccept: "/inbox/accept/recommendationResponse/",
    rcmdReject: "/inbox/reject/recommendationResponse/",
    sendRecommendationForRequest: "/inbox/send/recommendationInResponseToRequest/",
    reqAccept: "/inbox/accept/invitationRequest/",
    topicreqAccept: "/inbox/accept/topicJoinRequest/",
    topicreqReject: "/inbox/reject/topicJoinRequest/",
    reqReject: "/inbox/reject/invitationRequest/",
    rating: "/inbox/send/rating",
    inboxSendMsg: "/inbox/send/message",
    replyToMsg: "/inbox/send/replyToMessage",
    inboxReqRecv: "/inbox/allRequestsReceived",
    inboxReqRecvloadmore: "/inbox/allRequestsReceived?loadMore=true",
    inboxRcmdRecv: "/inbox/allRecommendationResponsesReceived",
    inboxRcmdRecvLoadMore: "/inbox/allRecommendationResponsesReceived?loadMore=true",
    inboxReqSent: "/inbox/allRequestsSent",
    inboxRcmdRespSent: "/inbox/allRecommendationResponsesSent",
    inboxMessageSent: "/inbox/allConversationsInSentItems",
    inboxReqSentLoadMore: "/inbox/allRequestsSent?loadMore=true",
    inboxRcmdRespSentLoadMore: "/inbox/allRecommendationResponsesSent?loadMore=true",
    inboxMessageSentLoadMore: "/inbox/allConversationsInSentItems?loadMore=true",
    inboxAllMsg: "/inbox/allConversationsInInbox",
    inboxMsgForContainerId: "/inbox/inboxConversation/",
    inboxMsgCon: "/inbox/allMessagesInConversationForUserMessageContainerEntry/",
    inboxAllMsgLoadMore: "/inbox/allConversationsInInbox?loadMore=true",
    reqRecDelete: "/inbox/delete/userRequestResponse/",
    rcmdRecDelete: "/inbox/delete/userRequestResponse/",
    msgRecDelete: "/inbox/delete/messageContainerEntry/",
    reqSentDelete: "/inbox/delete/userRequestResponse/",
    rcmdSentDelete: "/inbox/delete/userRequestResponse/",
    msgSentDelete: "/inbox/delete/messageContainerEntry/",
    trashDelete: "/inbox/delete/",
    inboxTrash: "/inbox/retrieve/trashedEntries/",
    inboxTrashloadmore: "/inbox/retrieve/trashedEntries?loadMore=true",
    inboxTrashRestore: "/inbox/restore/trashedEntry/",
    userTo: "/universalsearch/attendees/",
    myFriendsLookup: "/myFriendsLookup/",
    topicList: "/topic/allActive",
    topicDashboard: "/topic/topicDashboard",
    moretopicList: "/topic/allActive?loadMore=true",
    searchTopicList: "/topic/search",
    moretopicSearch: "/topic/search?loadMore=true",
    allJobs: "/jobs/filteredJobs",
    jobFilter: "/jobs/filteredJobs?loadMore=true",
    allJobsLoad: "/jobs/job/",
    postNewJob: "/jobs/submit",
    uploadTopicImage: "/topic/topicPic",
    createTopic: "/topic/create/topic",
    topicPermissions: "/topic/allTopicPermissions",
    allTopicTypes: "/topic/allTopicTypes",
    removeTopicSubscriber: "/topic/remove/topicSubscriber/",
    getTopic: "/topic/topic/",
    joinTopic: "/topic/join/",
    leaveTopic: "/topic/leave/",
    closeTopic: "/topic/close/",
    createTopicComment: "/topic/create/topicComment/",
    replyTopicComment: "/topic/reply/topicComment/",
    likeTopic: "/topic/like/topic/",
    unlikeTopic: "/topic/unlike/topic/",
    myTopics: "/topic/myTopics",
    myTopicsLoadMore: "/topic/myTopics?loadMore=true",
    myTopicsSubscriberLoadMore: "/topic/topicsIHaveSubscribedTo?loadMore=true",
    myTopicsSubscriber: "/topic/topicsIHaveSubscribedTo",
    courseMetaData: "/courses/metadata",
    courseStaticMetaData: "/courses/staticmetadata",
    courseImageUpload: "/fileupload",
    courseDocUpload: "/slidedeck",
    courseDocUploadSession: "/session/slidedeck",
    course: "/courses/",
    courseLite: "/sessions/approved/lite/",
    courseAttendee: "/course/",
    sessionPresenter: "/session/presenter/",
    editCourse: "/courses/edit",
    refund: "/refunds/",
    refundSearch: "/admin/refund/search",
    refundInit: "/refunds/",
    openCourses: "/opencourses",
    openCoursesFilters: "/courses/filters",
    searchAttendees: "/courses/attendee/search/",
    courseNameAutocomplate: "/autocompletes/courses/",
    courseownerNameAutocomplate: "/autocompletes/tutors/",
    enrolledCourse: "/courses/enrolled",
    enrolledCourseReview: "/courses/reviews/",
    searchCourse: "/search/courses",
    courseConnections: "/courses/connections",
    courseScheduledEndDate: "/courses/scheduledEndDate",
    courseScheduleSummary: "/courses/scheduleSummary",
    courseInvite: "/courses/invites",
    courseNotification: "/courses/notification",
    payoutCourse: "/payouts/",
    courseAdmin: "/admin/courses/",
    courseAction: "/admin/courses/action/",
    registerPaypal: "/payments/paypal",
    registerCC: "/payments/creditcard",
    applyCoupon: "/session/coupon/validity",
    addCoupon: "/session/coupon/",
    registerCourseFree: "/payments/nopay?id=",
    myAccountDetails: "/myAccount/details",
    userAccountStatus: "/myAccount/userAccountStatus/",
    deleteAccount: "/myAccount/deleteAccount",
    deleteAccountOTP: "/myAccount/accountDeletionOtp",
    myAccountDetailsUpdate: "/myAccount/updateNameAddressPhonePrivacy",
    myAccountDetailsUpdateEmail: "/myAccount/updateEmailDetails",
    myAccountDetailsUpdatePass: "/myAccount/updateCredentials",
    myAccountPaypal: "/myAccount/activatePayPal",
    myAccountPaypalUpdate: "/myAccount/editPayPalId",
    myAccountPaypalDeactivate: "/myAccount/deActivatePayPal",
    gmailUsersCheck: "/getLoggedInUser",
    gmailContacts: "/google/contacts",
    gmailNextContacts: "/google/contacts/next",
    gmailPrevContacts: "/google/contacts/previous",
    gmailInviteSent: "/google/inviteContactsToUvsity",
    billingPlans: "/billing/plans",
    upgradePlansall: "/upgrade/plan",
    upgradePlanCC: "/billing/creditcard/agreements",
    upgradePlanPaypal: "/billing/paypal/agreements",
    inviteEmail: "/homepage/emailInvite",
    pollHotJobs: "/homepage/poll/hotJobs",
    pollHotTopics: "/homepage/poll/hotTopics",
    pollNetworkUpdates: "/homepage/poll/networkUpdates",
    pollSuggestFriends: "/homepage/poll/suggestedFriends",
    pollTopCourses: "/homepage/poll/topCourses",
    pollProfileVisits: "/homepage/poll/profileVisits",
    pollLoggedInUser: "/poll/getLoggedInUser",
    pollSessionExpiryCheck: "/poll/sessionExpiryCheck",
    payoutList: "/admin/payout/list",
    makePayout: "/admin/payout/post/",
    makeManualPayout: "/admin/payout/manual/settlement/",
    canScheduleFree: "/courses/allowed/",
    ignoreNotification: "/web-notifications/ignore",
    meetingReqAcceptReject: "/calendar/owner/eventaction",
    getPaymentDetails: "/payments/details",
    spamTopicComment: "/topic/topic/comment",
    spamTopicCommentReply: "/topic/topic/comment/reply",
    spamInboxReply: "/inbox/message",
    addCoHost: "/session/cohost",
    addSpeaker: "/session/presenter",
    addQuestionnaire: "/questionnaire/create",
    updateQuestionnaire: "/questionnaire/update",
    getQuestionnaire: "/questionnaire",
    deleteQuestionnaire: "/questionnaire/delete",
    getSessionQuestionnaire: "/questionnaire/registration",
    getAnswerQuestionnaire: "/questionnaire/response",
    paidQuestionnaireRegister: "/payments/paypal",
    registrationPossible: "/courses/registrationPossible"
};
// Angular debug tools in the dev console
// https://github.com/angular/angular/blob/86405345b781a9dc2438c0fbe3e9409245647019/TOOLS_JS.md
var _decorateModuleRef = function (value) { return value; };
var ɵ0 = _decorateModuleRef;
if ('production' === ENV) {
    enableProdMode();
    // Production
    _decorateModuleRef = function (modRef) {
        disableDebugTools();
        return modRef;
    };
    PROVIDERS = PROVIDERS.slice();
}
else {
    _decorateModuleRef = function (modRef) {
        var appRef = modRef.injector.get(ApplicationRef);
        var cmpRef = appRef.components[0];
        var _ng = window.ng;
        enableDebugTools(cmpRef);
        window.ng.probe = _ng.probe;
        window.ng.coreTokens = _ng.coreTokens;
        return modRef;
    };
    // Development
    PROVIDERS = PROVIDERS.slice();
}
export var decorateModuleRef = _decorateModuleRef;
export var ENV_PROVIDERS = PROVIDERS.slice();
export { ɵ0 };
//# sourceMappingURL=environment.js.map